import React from 'react'
import Banner from "./banner"
import Section1 from "./section1"
import Section2 from "./section2"
import Section3 from "./section3"
import { Helmet } from 'react-helmet';

function index() {
    return (
        <>
            <Helmet>
                <title>About Ecom | Empowering Businesses with Smart E-Commerce Solutions</title>
                <meta name="description" content="Discover the story behind Ecom — a scalable and user-friendly e-commerce platform built to help businesses thrive online with fast, secure, and customizable storefronts." />
            </Helmet>
            <div>
                <Banner />
                <Section1 />
                <Section2 />
                <Section3 />

            </div>
        </>

    )
}

export default index